export const version = {
    version: require('../../../../package.json').version
};
